export interface Position {
  nr: number;
  vorname: string;
  nachname: string;
  initialen: string;
  groesse: string;
  menge: number;
  unsicher: boolean;
  anmerkung: string;
  erledigt: boolean;
}

export interface Kontrollsumme {
  groesse: string;
  anzahl: number;
}

export interface BogenOptionen {
  bogenBreiteMm: number;
  buchstabenHoeheMm: number;
  abstandMm: number;
  randMm: number;
  schrift: string;
  groessenLabels: boolean;
}

export interface Auftrag {
  id?: number;
  titel: string;
  artikel: string;
  hinweise: string;
  quelleDateiname?: string | null;
  positionen: Position[];
  kontrollsummen: Kontrollsumme[];
  bogenOptionen?: Partial<BogenOptionen> | null;
  gedrucktAm?: string | null;
  createdAt?: string;
}

export interface AuftragKurz {
  id: number;
  titel: string;
  artikel: string;
  anzahl: number;
  erledigt: number;
  positionen: number;
  groessen: Kontrollsumme[];
  gedrucktAm: string | null;
  createdAt: string;
}

export interface Einstellungen {
  defaults: BogenOptionen;
  grenzen: Record<'bogenBreiteMm' | 'buchstabenHoeheMm' | 'abstandMm' | 'randMm', { min: number; max: number }>;
  schriften: { key: string; name: string }[];
}

export const BASIS = '/programmes/druck-initialen';
